<section *ngIf="info!.length !== 0" class="table-container">
	<table mat-table [dataSource]="dataSource" class="benefitTable">
		<ng-container *ngFor="let header of headers" [matColumnDef]="header">
			<th mat-header-cell *matHeaderCellDef class="header-cell">
				<div class="header-content">
					<span>{{ getHeaderLabel(header) }}</span>
					<button
						mat-icon-button
						(click)="openFilterMenu(header)"
						class="filter-button"
						[class.has-filter]="hasActiveFilter(header)"
					>
						<mat-icon>filter_list</mat-icon>
					</button>
				</div>
			</th>
			<td mat-cell *matCellDef="let row">
				{{ row[header] }}
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</section>

<ng-container *ngIf="info !== null && info?.length === 0">
	<div class="noData">
		<p class="noData__text">Nenhum dado encontrado</p>
	</div>
</ng-container>

<mat-paginator [pageSizeOptions]="[25, 50, 75, 100]" [pageSize]="25" showFirstLastButtons></mat-paginator>